var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMapWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.739,
    height: 47.737,
    viewBox: "0 0 47.739 47.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-6.306 -6.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M48.142,84.289H35.666a75.684,75.684,0,0,1-5.491,7.6,75.68,75.68,0,0,1-5.491-7.6H12.209l-5.9,15.475H54.045Z",
    transform: "translate(0 -45.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M46,6.31A12.706,12.706,0,0,0,33.29,19.015C33.215,31.138,46,46.172,46,46.172S58.775,31.138,58.7,19.016A12.706,12.706,0,0,0,46,6.31Zm0,18.1a5.391,5.391,0,1,1,5.391-5.391A5.391,5.391,0,0,1,46,24.406Z",
    transform: "translate(-15.82 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M63.826,87.877,40,96.35,30.72,84.29H39a75.606,75.606,0,0,0,5.49,7.6,75.608,75.608,0,0,0,5.49-7.6H62.457Z",
    transform: "translate(-14.313 -45.718)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M29.96,109.808l23.581-8.388L60,109.808Z",
    transform: "translate(-13.868 -55.761)",
    fill: "#f37021"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapWhite);
export default __webpack_public_path__ + "static/media/icon-map-white.86e7f9df26918dd3e8402717070cc733.svg";
export { ForwardRef as ReactComponent };